"use client";
import { Button } from "@/components/ui/button";
import ArrowDownRightIcon from "@heroicons/react/24/solid/ArrowDownRightIcon";
import { Link } from "@/components/CustomLink";
import BulkOfferMobileImage from "@/components/layout/bulk-offer/images/BulkOfferMobileImage";
import { useTranslation } from "@/hooks/translationContext";
import { CLICK_QUOTE_EVENT_SECTIONS, PLAUSIBLE_GOAL_KEYS } from "@/@core/constants/plausible";
import { usePlausible } from "next-plausible";
import { useContactWithVenuesLink } from "@/hooks/useContactWithVenuesLink";
import { useIsAskQuestionEnabled } from "@/hooks/useIsAskQuestionEnabled";

export default function BulkOfferMobile() {
  const { t } = useTranslation();
  const plausible = usePlausible();
  const getQuoteHref = useContactWithVenuesLink();
  const isAskQuestionEnabled = useIsAskQuestionEnabled();

  const getQuoteTitle = () => {
    return t("quote-button-title");
  };

  const sendPlausibleEvent = () => {
    plausible(PLAUSIBLE_GOAL_KEYS.CLICK_QUOTE_EVENT, {
      props: {
        section: CLICK_QUOTE_EVENT_SECTIONS.MOBILE_BULK_OFFER,
      },
    });
  };

  if (!isAskQuestionEnabled) return null;

  return (
    <Link
      onClick={() => sendPlausibleEvent()}
      title={getQuoteTitle()}
      aria-label={getQuoteTitle()}
      href={getQuoteHref}
    >
      <div className="flex md:hidden py-6">
        <div
          className="text-white w-full rounded-[32px] p-6
            bg-gradient-to-r from-rose-600 to-pink-700 h-[178px] "
        >
          <div className="flex relative pl-36 items-end justify-between">
            <BulkOfferMobileImage />

            <div className="flex flex-col items-start justify-end">
              <span className="text-xs font-[500]">
                {t("bulk-offer-welcome-title")}
              </span>
              <span className="text-sm font-bold">
                {t("bulk-offer-card-description")}
              </span>
              <div className="flex items-center gap-2">
                <span className="text-xs">
                  {t("bulk-offer-card-short-description")}
                </span>

                <ArrowDownRightIcon className="size-4" />
              </div>

              <div className="mt-5">
                <Button
                  variant="white"
                  className="flex w-[142px] text-secondary justify-center items-center !text-center text-sm font-bold sm:px-2 sm:py-[12px] px-1 py-[3px]"
                >
                  {getQuoteTitle()}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
}
